import { MachineDto } from './machine.dto';
import { ScrapCauseDto } from './scrap-cause.dto';

export class ScrapReasonDto {
    id!: number;
    text!: string;
    machines?: MachineDto[];
    scrapCauses?: ScrapCauseDto[];
}
